import { ChangeDetectorRef, Component, Input, OnInit, } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { SurveyService } from '../../services/survey.service';


@Component({
  selector: 'app-header-question',
  templateUrl: './header-question.component.html',
  styleUrls: ['./header-question.component.scss'],
})
export class HeaderQuestionComponent implements OnInit {

  @Input() title: any;
  @Input() subtitle: any;
  @Input() section_index: any;
  @Input() section_count: any;

  constructor(public router: Router,
    private cdRef: ChangeDetectorRef,
    public surveyService: SurveyService,
    public menuCtrl: MenuController,
  ) {
  }
  ngOnInit() {
   
  }
  ngOnChanges(changes) {
    console.log('changes')
    this.title = changes.title.currentValue
    this.subtitle = changes.subtitle ? changes.subtitle.currentValue : this.subtitle
    this.section_index = changes.section_index ? changes.section_index.currentValue : this.section_index
    this.section_count = changes.section_count ? changes.section_count.currentValue : this.section_count
    document.getElementById('title').innerText = this.title
    document.getElementById('subtitle').innerText = this.subtitle
    document.getElementById('head').innerText = 'Pregunta ' + this.section_index + ' de ' + this.section_count
    this.cdRef.detectChanges()
  }

}
